import { createSelector } from 'reselect';
import { maybe } from '@/utils';
import currentSessionObjSelector from './currentSessionObj';
import currentSessionSelector from './currentSession';

export default createSelector(
  currentSessionObjSelector,
  currentSessionSelector,
  (currentSession, sessionId) => {
    return {
      teamPlan: maybe(currentSession, 'sessionInfo', 'teamPlan'),
      sessionId,
      isAdmin: maybe(currentSession, 'sessionInfo', 'teamInfo', 'isAdmin'),
    };
  }
);



// WEBPACK FOOTER //
// ./src/selectors/paywall.js